<template>
    <div class="app-container">
    <el-row class="headTop">
        <el-col :span="4">
          分店：
          <el-select class="w150" v-model="shopNum" placeholder="请选择分店"
          @change="changeShopData(shopNum)">
           <el-option
            v-for="item in this.shopList"
            :key="item.shopNum"
            :label="item.name"
            :value="item.shopNum"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-show="showBtn">
          <el-button icon="el-icon-refresh" type="primary" @click="synData()">同步数据</el-button>
        </el-col>
    </el-row>
    <el-dialog title="推荐类型"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="推荐数量" prop="number">
            <el-input class="w220" v-model.number="formparams.number" placeholder="请输入推荐数量" maxlength="2"></el-input>
          </el-form-item>
           <el-form-item label="显示状态" prop="status">
             <el-select v-model="formparams.status" placeholder="请选择">
                <el-option
                v-for="item in this.statusType"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="推荐方式" prop="recommendType">
             <el-select v-model="formparams.recommendType" placeholder="请选择">
                <el-option
                v-for="item in this.recommendTypeS"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
                ></el-option>
              </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="recommendname" label="推荐模块"></el-table-column>
        <el-table-column label="推荐数量">
          <template slot-scope="scope">
            <div> {{scope.row.number}} </div>
          </template>
        </el-table-column>
        <el-table-column label="显示状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status==0"> 否 </div>
            <div v-if="scope.row.status==1"> 是 </div>
          </template>
        </el-table-column>
        <el-table-column label="推荐方式">
          <template slot-scope="scope">
            <div v-if="scope.row.recommendtype==0"> 自动 </div>
            <div v-if="scope.row.recommendtype==1"> 手动 </div>
          </template>
        </el-table-column>
        <el-table-column width="300" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="warning" @click="setInfo(scope.row)">配置详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {
  getRecommendType,
  updateRecommendType,
  getPrivateCourse,
  getEJtInfo,
  deleteRecommendinfo, 
  getCardsSell, 
  getRecommendinfo,
  inserteRecommendinfo,
  insertRecommendType,
  getTbCourse,
  insertTuancaorec,
  insertTbCourse,
  getShops
} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    var validDate = (rule,value,callback) => {
        if(!this.date[0] || !this.date[1]){
            callback(new Error("请选择日期"))
        }else{
            callback()
        }
    }
    return {
      loading: true,
      dialogVisible: false,
      hideUpload: false,
      type:'',//类型查询
      query:{
      },
      shopNum:'',
      remaNumber:'',
      date:[],//开始时间结束时间
      pickerBeginDateBefore:{
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      shopList:[],//分店
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      getPtClassList:[],//私教项目
      startTime:'',
      endTime:'',
      rules:{
        number:[
          {type:'number', required: true, message: '请输入数量', trigger: 'blur' }
        ],
        status:[{ required: true, message: '请选择显示状态', trigger: 'blur' }],
        recommendType:[{ required: true, message: '请选择推荐方式', trigger: 'blur' }],
      },
      statusType:[
        {lable:'显示',value:1},
        {lable:'不显示',value:0}
      ],
      recommendTypeS:[
        {lable:'手动',value:1},
        {lable:'自动',value:0}
      ],
      timeList:[],
      addType:1,
      formparams:{
          id:'',
          status:'',
          number:'',
          recommendType:''
      },
      newData:[],
      formData:{},
      fileList:[],
      tableData:[],
      showBtn:false,
      dataLength:0,
      total: 0,
      currentPage: 1,
      params: {
        page: 1,
        size: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
  },
  mounted() {
  },
  methods: {
    // inserteRecommendinfo
    getTableList(){
      getRecommendType({shopNum:this.shopNum}).then((res)=>{
        if(res.msg == "success"){
            this.tableData = res.data
            if(res.data.length == 0){
              this.showBtn= true
            }
        }
        this.loading = false
      })
    },
    // getRecommendinfo
    getTableList2(){
      getRecommendinfo().then((res)=>{
        if(res.msg == "success"){
          this.tableData2 = res.data
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(sessionStorage.getItem('hotShopNum')){
          this.shopNum = sessionStorage.getItem('hotShopNum')
        } else {
          this.shopNum = this.shopList[0].shopNum
        }
        this.getTableList()
      })
    },
    //修改分店
    changeShopData(shopNum){
      sessionStorage.setItem('hotShopNum',shopNum)
      this.getTableList()
    },
    //新增分店进行同步
    synData(){
      this.loading = true
      insertRecommendType({shopNum:this.shopNum}).then(res=>{
        if(res.msg == "success"){
          this.$message({
            type:'success',
            message:"同步成功"
          })
          this.getTableList()
        } else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    //配置详情
    setInfo(row){
      this.$router.push({path:'/hotRecom/hotInfo',query:{shopNum:row.shopNum,type:row.type,num:row.number,name:row.recommendname}})
    },
    //查询数据数量
    getDataLength(row){
      getRecommendinfo({shopNum:row.shopNum,type:row.type}).then((res)=>{
        if(res.msg == "success"){
            this.dataLength = res.data.length
        }
        this.loading = false
      })
    },
    //编辑
    edit(row){
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.status=row.status
      this.formparams.number=row.number
      this.formparams.recommendType=row.recommendtype
      this.getDataLength(row)
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          if(this.formparams.number<this.dataLength){
            this.$message.error('当前设置数量小于已设置项目总数，请删除多余项目后重试')
            return
          }
          updateRecommendType(this.formparams).then(res=>{
            if(res.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
                this.getTableList()
              } else {
                this.$message({
                  type:'error',
                  message:res.data
                })
              }
          })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.dialogVisible2= false
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// hotRecom.vue?b31ccb82